import 'magnific-popup';

export default function photos() {

  $('.block-photos__content-list a').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true
		}
  });
  
  showPhotos(8);

  $('.block-photos__content-action a').click(function(e){
    e.preventDefault();
    showPhotos(5);
  });

  function showPhotos(count) {
    $('.block-photos__content-list .item').not('.active').each(function(i){
      if (i < count) $(this).addClass('active');
    });

    if ($('.block-photos__content-list .item').not('.active').length == 0) {
      $('.block-photos__content-action').hide();
    }
  }
}